import { render, staticRenderFns } from "./EventProfile.vue?vue&type=template&id=41fb10db&scoped=true&"
import script from "./EventProfile.vue?vue&type=script&lang=js&"
export * from "./EventProfile.vue?vue&type=script&lang=js&"
import style0 from "./EventProfile.vue?vue&type=style&index=0&id=41fb10db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fb10db",
  null
  
)

export default component.exports